/**
 * Псевдоним пункта меню — второй вход на путь, который уже занят другим пунктом.
 *
 * Зачем нужен. antd Menu требует УНИКАЛЬНЫЙ `key` и на дубле молча перестаёт
 * рисовать один из двух пунктов. При этом связка «key = адрес навигации» —
 * наша договорённость, а не требование библиотеки: в `handleMenuClick` рядом уже
 * живут ветки `external::` и `open-swagger`, и путь разбирается только в
 * запасной ветке `key.startsWith('/')`.
 *
 * Живой случай: услуги. В v4 они лежат в разделе «Тарифы» (мышечная память
 * оператора), в V5 тот же экран отдаёт ещё и хаб настроек. Убрать любой из двух
 * входов — потерять либо привычку, либо согласованность с хабом.
 *
 * Почему не query. Раньше здесь стоял `?from=tariffs`: ключи различались, но
 * ценой служебного параметра в адресной строке, который экран не читает и
 * который оператор видит в закладке. Псевдоним решает ту же задачу, не трогая
 * адрес.
 *
 * Подсветку в меню владеет КАНОНИЧЕСКИЙ пункт: адрес у обоих входов один, и по
 * URL различить их невозможно в принципе — см. `menuPathKeys`
 * в useSidebarNavigation.ts.
 */
export const MENU_ALIAS_PREFIX = 'alias::';

/** Ключ-псевдоним для пути, уже занятого другим пунктом меню. */
export function menuAliasKey(path: string): string {
  return `${MENU_ALIAS_PREFIX}${path}`;
}

/** Адрес навигации из ключа. Не псевдоним возвращается как есть. */
export function stripMenuAlias(key: string): string {
  return key.startsWith(MENU_ALIAS_PREFIX) ? key.slice(MENU_ALIAS_PREFIX.length) : key;
}

/**
 * Предустановка экрана для входа-псевдонима — то, чем второй вход отличается от
 * первого. Едет react-router `state`, а не query: адрес остаётся чистым (ровно
 * та причина, по которой псевдоним заменил `?from=`).
 *
 * Экран обязан пережить ОТСУТСТВИЕ предустановки: при прямом заходе по адресу и
 * после перезагрузки state пуст, и экран должен открыться в состоянии по
 * умолчанию, а не сломаться.
 *
 * «Услуги» здесь нет: тот псевдоним ведёт на неизменённый экран.
 */
export const MENU_ALIAS_PRESETS: Record<string, Record<string, unknown> | undefined> = {
  // Пункт «Активность в интернете» открывает общий экран активности со второй
  // метрикой. Экрана-двойника нет: обе метрики отвечают на один вопрос и должны
  // сохранять поиск и период при переключении источника.
  '/customers/activity': { activitySource: 'internet' },
};
